import { Resource as e } from "@coveo/platform-client";
//#region src/resources/PipelineSettingsResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v2/admin/pipelines";
	}
	listAvailableSettings(e) {
		return this.api.get(this.buildPath(`${t.baseUrl}/settings/metadata`, {
			...e,
			organizationId: this.api.organizationId
		}));
	}
	list(e, n) {
		return this.api.get(this.buildPath(`${t.baseUrl}/${e}/settings`, {
			...n,
			organizationId: this.api.organizationId
		}));
	}
	get(e, n) {
		return this.api.get(this.buildPath(`${t.baseUrl}/${e}/settings/${n}`, { organizationId: this.api.organizationId }));
	}
	create(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/${e}/settings`, { organizationId: this.api.organizationId }), n);
	}
	update(e, n, r) {
		return this.api.put(this.buildPath(`${t.baseUrl}/${e}/settings/${n}`, { organizationId: this.api.organizationId }), r);
	}
	delete(e, n) {
		return this.api.delete(this.buildPath(`${t.baseUrl}/${e}/settings/${n}`, { organizationId: this.api.organizationId }));
	}
	bulkDelete(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/${e}/settings/bulkDelete`, { organizationId: this.api.organizationId }), { ids: n });
	}
	bulkGet(e, { ids: n, ...r }) {
		return this.api.post(this.buildPath(`${t.baseUrl}/${e}/settings/bulkGet`, {
			organizationId: this.api.organizationId,
			...r
		}), { ids: n });
	}
	copy(e, n) {
		return this.api.post(this.buildPath(`${t.baseUrl}/${e}/settings/copy`, { organizationId: this.api.organizationId }), n);
	}
	move(e, n, r) {
		return this.api.put(this.buildPath(`${t.baseUrl}/${e}/settings/${n}/move`, { organizationId: this.api.organizationId }), r);
	}
};
//#endregion
export { t as PipelineSettingsResource };

//# sourceMappingURL=PipelineSettingsResource.js.map